import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import LiveChart from "../../sensor/LiveChart";
import React, { useState, useEffect } from "react";
import { companyProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { toast } from "react-toastify";
import { renderImage } from "../../../utils/helper.jsx";
import Styles from "./index.modules.css";
import NormalInput from "../../../components/form/HorizontalNormalInput/index.jsx";
import { PermissionChecker } from "../../../components/PermissionChecker";
function CompanyConfiguration() {
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(false);
  const [companyFile, setcompanyFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [dataToSend, setDataToSend] = useState({
    company_name: "",
    company_logo: "",
    currency: "USD",
    currency_symbol: "$",
    company_address: "",
    overview_level: "",
    contact_person: "",
    timezone: "+8",
    contact_number: "",
    contact_email: "",
  });
  async function getCompany() {
    try {
      const res = await companyProfile.list();
      const data = await parserAPI(res);
      setCompany(data);
    } catch (e) {
      console.error(e);
    }
  }
  useEffect(() => {
    getCompany();
  }, []);
  useEffect(() => {
    if (company) {
      getRecord();
    }
  }, [company]);
  async function getRecord() {
    setPreview(renderImage(`/machine/attachment/${company.company_logo}`));
    setDataToSend((prevData) => ({
      ...prevData,
      company_name: company.company_name,
      company_logo: company.company_logo,
      currency: company.currency,
      currency_symbol: company.currency_symbol,
      timezone: company.timezone,
      company_address: company.company_address,
      overview_level: company.overview_level,
      contact_person: company.contact_person,
      contact_number: company.contact_number,
      contact_email: company.contact_email,
    }));
  }

  useEffect(() => {
    if (!companyFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(companyFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [companyFile]);
  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setcompanyFile(undefined);
      return;
    }
    setcompanyFile(e.target.files[0]);
  };

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleEdit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      const res = await companyProfile.update(company.id, hasil, companyFile);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          getCompany();
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      const res = await companyProfile.create(hasil, companyFile);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          getCompany();
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Company Profile</li>
          </ol>
          <h1 className="page-header mb-0">Company Profile</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-4">
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Company Profile
            </CardHeader>
            <CardBody>
              <div className="row">
                <div className="col-lg-12 col-sm-12 mb-2">
                  <Card>
                    <CardBody style={{ padding: "7px" }}>
                      <label htmlFor="filesupload" style={{ width: "100%" }}>
                        {preview ? (
                          <>
                            <img
                              src={preview}
                              className="img-thumbnail"
                              alt=""
                            />
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                                cursor: "pointer",
                                marginTop: "5px",
                              }}
                            >
                              Change Photo <br />{" "}
                              <i className="fa fa-camera"></i>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              style={{
                                cursor: "pointer",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                minHeight: "150px",
                                alignItems: "center",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <i className="fa fa-camera"></i>
                              <div>Add a Photo</div>
                            </div>
                          </>
                        )}
                      </label>
                      <input
                        id="filesupload"
                        onChange={onSelectFile}
                        style={{ visibility: "hidden" }}
                        type="file"
                        accept="image/png, image/jpeg"
                      />
                    </CardBody>
                    <CardFooter className="text-theme fw-bold text-center">
                      {company?.company_name}
                    </CardFooter>
                  </Card>
                </div>
                <div className="col-lg-12 col-sm-12">
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Contact Person</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {company?.contact_person}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Contact Number</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {company?.contact_number}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Email</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {company?.email}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Currency</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {company?.currency} ({company?.currency_symbol})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Company Address
            </CardHeader>
            <CardBody className="card-body pb-2">
              {company?.company_address}
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-8">
          <Card className="mb-4">
            <CardHeader>Update Company Profile</CardHeader>
            <CardBody>
              <div
                style={{
                  padding: "20px",
                  paddingTop: "50px",
                  position: "relative",
                }}
              >
                <div className={"row justify-content-center"}>
                  <div className={"col-md-12 col-sm-12"}>
                    <div className={"form-group  mb-3"}>
                      <NormalInput
                        required
                        type="text"
                        className="form-control"
                        value={dataToSend["company_name"]}
                        label="Company Name"
                        onchange={handleOnchange}
                        name="company_name"
                      />
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Company Address</label>
                      <input
                        type="text"
                        className="form-control"
                        value={dataToSend["company_address"]}
                        label="Address"
                        onChange={handleOnchange}
                        name="company_address"
                      />
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Time Zone</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={"TimeZone (+8)"}
                        value={dataToSend["timezone"]}
                        label="Time Zone"
                        onChange={handleOnchange}
                        name="timezone"
                      />
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Currency</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={"Currency Used"}
                        value={dataToSend["currency"]}
                        label="Currency"
                        onChange={handleOnchange}
                        name="currency"
                      />
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Currency Symbol</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={"Currency Symbol"}
                        value={dataToSend["currency_symbol"]}
                        label="Currency Symbol"
                        onChange={handleOnchange}
                        name="currency_symbol"
                      />
                    </div>
                    <div className={"form-group mb-3"}>
                      <label>Overview First View</label>
                      <select
                        className="form-control"
                        value={dataToSend["overview_level"]}
                        onChange={handleOnchange}
                        name="overview_level"
                      >
                        {company?.location_wording
                          ?.split(",")
                          .map((item, index) => (
                            <option value={index + 1}>{item}</option>
                          ))}
                      </select>
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Contact Person</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={"Enter Name of Contact Person"}
                        value={dataToSend["contact_person"]}
                        label="Contact Person"
                        onChange={handleOnchange}
                        name="contact_person"
                      />
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Contact Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={"Enter Contact Number"}
                        value={dataToSend["contact_number"]}
                        label="Contact Number"
                        onChange={handleOnchange}
                        name="contact_number"
                      />
                    </div>

                    <div className={"form-group  mb-3"}>
                      <label>Email</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={"Enter Email"}
                        value={dataToSend["contact_email"]}
                        label="Email"
                        onChange={handleOnchange}
                        name="contact_email"
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{ textAlign: "center", marginTop: "5px" }}
                  mt={2}
                  mb={1}
                >
                  <PermissionChecker
                    permissions={["edit company profile"]}
                    hideIfNotAllowed
                  >
                    <button
                      className={"btn btn-theme"}
                      disabled={!dataToSend["company_name"]}
                      color="info"
                      onClick={handleEdit}
                    >
                      SAVE
                    </button>
                  </PermissionChecker>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default CompanyConfiguration;
